/** Presets map to API values `set` and `not-set` (hyphen). */

export const CASE_ID_FILTER_PRESET_OPTIONS = ['set', 'not_set'] as const;

export function normalizeCaseIdFilterToken(raw: string): string {
  const t = raw.trim();
  if (!t) {
    return '';
  }
  const lower = t.toLowerCase();
  if (lower === 'set') {
    return 'set';
  }
  if (lower === 'not_set' || lower === 'not-set') {
    return 'not_set';
  }
  return t.trim().toUpperCase();
}

export function parseCaseIdFilterQueryParam(raw: string | null | undefined): Array<string> {
  if (!raw?.trim()) {
    return [];
  }
  return raw
    .split(',')
    .map((segment) => normalizeCaseIdFilterToken(segment))
    .filter(Boolean);
}

export function serializeCaseIdFilterForApi(tokens: Array<string>): string {
  return tokens
    .map((token) => {
      if (token === 'not_set') {
        return 'not-set';
      }
      if (token === 'set') {
        return 'set';
      }
      return token.trim().toUpperCase();
    })
    .join(',');
}

export function caseIdFilterOptionLabel(option: string): string {
  if (option === 'set') {
    return 'Case ID set';
  }
  if (option === 'not_set') {
    return 'Case ID not set';
  }
  return option;
}
